/**
 * Capa da impressão (modelo AD Digital): cada tela diz o que vai na capa (ex.: na página do projeto, o cliente e o nome
 * do projeto; nas demais, o título do cabeçalho da página). Vale a tela aberta mais recente; sem nenhuma, a capa usa
 * o título da tela (o primeiro h1), lido na hora de imprimir.
 */
import { useEffect, useSyncExternalStore } from 'react';

export interface PrintCover { title: string; subtitle?: string | null }

const stack: { key: object; cover: PrintCover }[] = [];
let current: PrintCover | null = null;
const listeners = new Set<() => void>();

function update() {
  current = stack.at(-1)?.cover ?? null;
  listeners.forEach((l) => l());
}

/** A tela define a capa enquanto estiver aberta. */
export function usePrintCover(title: string | null | undefined, subtitle?: string | null) {
  useEffect(() => {
    if (!title) return;
    const entry = { key: {}, cover: { title, subtitle } };
    stack.push(entry);
    update();
    return () => {
      const i = stack.indexOf(entry);
      if (i >= 0) stack.splice(i, 1);
      update();
    };
  }, [title, subtitle]);
}

export function useCurrentPrintCover() {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => current);
}
